export const CartProductos = {
  namespaced: true,
  state() {
    return {
  
      items: JSON.parse(localStorage.getItem('cartItems')) || [],// Aquí almacenaremos los productos del carrito
    };
  },
  getters: {
    totalPriceCart(state) {
      // Calcula el precio total del carrito
      return state.items
        .reduce((total, item) => total + item.precio2 * item.cantidad, 0)
        .toFixed(2); // Asegura que el total sea un string con dos decimales
    },
    allCartProducts(state) {
      // Retorna todos los productos del carrito
      return state.items;
    },
    cartItemCountProduct: (state) => {
      return state.items.length;
    },
  },
  mutations: {
    ADD_TO_CART_PRODUCT(state, product) {
      const existingProduct = state.items.find(
        (item) => item.codigo === product.codigo
      );
      if (existingProduct) {
        existingProduct.cantidad++;
      } else {
        // Asegúrate de inicializar 'cantidad' correctamente
        state.items.push({ ...product, cantidad: product.cantidad });
      }
      localStorage.setItem('cartItems', JSON.stringify(state.items));
    },
    REMOVE_FROM_CART_PRODUCT(state, productCode) {
      const index = state.items.findIndex(
        (item) => item.codigo === productCode
      );
      if (index !== -1) {
        state.items.splice(index, 1);
      }
      localStorage.setItem('cartItems', JSON.stringify(state.items));
    },
    INCREMENT_QUANTITY_PRODUCT(state, productCode) {
      const product = state.items.find((item) => item.codigo === productCode);
      if (product) product.cantidad++;
      localStorage.setItem('cartItems', JSON.stringify(state.items));
    },
    DECREMENT_QUANTITY_PRODUCT(state, productCode) {
      const product = state.items.find((item) => item.codigo === productCode);
      if (product && product.cantidad > 1) product.cantidad--;
      localStorage.setItem('cartItems', JSON.stringify(state.items));
    },
  },
  actions: {
    addToCartProduct({ commit }, product) {
      commit('ADD_TO_CART_PRODUCT', product);
    },
    removeFromCartProduct({ commit }, productCode) {
      commit('REMOVE_FROM_CART_PRODUCT', productCode);
    },
    incrementQuantityProduct({ commit }, productCode) {
      commit('INCREMENT_QUANTITY_PRODUCT', productCode);
    },
    decrementQuantityProduct({ commit }, productCode) {
      commit('DECREMENT_QUANTITY_PRODUCT', productCode);
    },
  },
};
